export type ExportFormat = 'PDF' | 'EXCEL' | 'OBX' | 'OBK' | '3DS' | 'DWG' | 'FBX' | 'SKP' | 'GAEB' | 'Revit' | 'GLB' | 'USDZ';

export const ExportGeometryFormat: {[key: string]: Array<string>} = {
    USDZ: [
        'format=USD',
        'ascii=false',
        'centerXZ=true'
    ],
    GLB: [
        'format=GLTF',
        'ascii=false',
        'texTrans=true',
        'centerXZ=true'
    ],
    DWG: [
        'format=DWG',
        'hideSubArticles=false',
        'materials=true',
        'no2D=true',
        'textures=true',
        'edwg=true'
    ],
    DXF: [
        'format=DWG',
        'dxf=true',
        'hideSubArticles=false',
        'no2D=true',
        'textures=true',
        'materials=true'
    ],
    FBX: [
        'format=FBX',
        'hideSubArticles=false',
        'scale=1.0',
        'textures=true',
        'materials=true',
        'no2D=true',
        'textureToColor=false',
        'duplicateFaces=true'
    ],
    '3DS': [
        'format=3DS',
        'hideSubArticles=false',
        'textures=true'
    ],
    SKP: [
        'format=SKP',
        'hideSubArticles=false',
        'no2D=true',
        'textures=false',
        'textureToColor=true'
    ],
    Revit: [
        'format=GFX',
        'revit=true',
        'hideSubArticles=false',
        'hierarchyMode=MatrixStack',
        'obx.enabled=true'
    ]
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/ExportFormats.ts